import ReactDOM from 'react-dom';
import React from 'react';

const { LP } = window;

class CollectionBuilder {
  constructor() {
    if (LP.config.load_builder) {
      const root = document.getElementById('new-builder-wrap');
      if (root) {
        if (LP.config.logged_in) {
          import(/* webpackChunkName: "cb" */ './authenticated/main').then((module) => {
            ReactDOM.createRoot(root).render(
              React.createElement(module.default)
            );
          });
        } else {
          import(/* webpackChunkName: "vcb" */ './visitor/main').then((module) => {
            ReactDOM.createRoot(root).render(
              React.createElement(module.default)
            );
          });
        }
      }
    }
  }
}

export default CollectionBuilder;
